import ShoppingList from './Shopping/ShoppingList';
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="container">
      <h1>Shopping list</h1>
      <ShoppingList />
    </div>
  );
}

export default App;
